import { registerComponent } from "helpers";

registerComponent(
  "results-count",
  class ResultsCount extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.resultsCount;

      this.renderResultsCount();
    }

    renderResultsCount() {
      fetch(this.endpoint)
        .then((response) => response.json())
        .then((data) => {
          this.innerHTML = data.results_count;
          this.removeAttribute("hidden");
        });
    }
  },
);
